import { OFFSET_DIRECTION } from '../constants'
import { END_RULE_TYPE } from '../constants/endRulesTypes'

export const formatRelativeToVisitEndRule = rule => {
  const amount = rule.offset?.amount ?? rule.offset?.value ?? 0
  const unit = rule.offset?.unit || 'days'
  const direction = rule.offset?.direction === OFFSET_DIRECTION.before ? 'before' : 'after'
  return `${amount} ${unit} ${direction} anchoring visit`
}

export const summarizeRelativeToVisitEndRule = (rule, { afterOccurrencesPrefix = '' } = {}) => {
  const type = rule?.type
  if (type === END_RULE_TYPE.afterNOccurrences || type === 'after_n_occurrences') {
    const count = rule.count ?? rule.recurrences
    if (count != null) {
      const prefix = afterOccurrencesPrefix || 'After'
      return `${prefix} ${count} occurrences`
    }
  }
  if (type === END_RULE_TYPE.relativeToVisit || type === 'relative_to_visit') {
    return formatRelativeToVisitEndRule(rule)
  }
  return null
}
